import { AlertController, Platform, Slides } from 'ionic-angular';
import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { BrowserTab } from '@ionic-native/browser-tab';
import { NavController, LoadingController, Content } from 'ionic-angular';
import { Network } from '@ionic-native/network';
import { Subscription } from 'rxjs';

import { AdicionarContatoPage } from '../adicionar-contato/adicionar-contato';
import { Area, TipoArea } from '../../models/area';
import { AreaLocalProvider } from '../../providers/area-local/area-local';
import { Atalho } from '../../models/atalho';
import { BrComDao } from '../../service/BrComDao';
import { BrComService } from '../../service/BrComService';
import { Contato } from '../../models/contato';
import { ContatoLocalProvider } from '../../providers/contato-local/contato-local';
import { EmpresaLocalProvider } from '../../providers/empresa-local/empresa-local';
import { PushService } from '../../service/PushService';
import { readValueFromConfig } from '../../lib/util';
import { RemoteService } from '../../service/RemoteService';
import { StatusBar } from '@ionic-native/status-bar';
import { TipoLayout } from '../../shared/interfaces';
import { MenuController } from 'ionic-angular';

import { ConversaContatoPage } from '../conversa-contato/conversa-contato';


@Component({
  selector: 'page-inicial',
  templateUrl: 'inicial.html'
})
export class InicialPage {

  @ViewChild(Content) content: Content;
  @ViewChild(Slides) slides: Slides;
  @ViewChild(ConversaContatoPage) childRef: ConversaContatoPage;
  
  public userData: any;

  public empresa: any;
  public posicao = 0;
  public autenticado = false;
  public MostrarMensagemTrocarSenhaPadrao = false;
  public atalhos = [];
  public URLLogotipoEmpresa = "";
  public mostraFacebook = true;
  public mostraTwitter = true;
  public mostraWeb = true;
  public nomeEmpresa;
  private appDomain = "";
  public tipoLayout: TipoLayout;
  public areaSelecionada: Area;
  public contatoSelecionado: Contato;
  public aba: string;
  private subscriptions: Subscription;

  constructor(public lc: ChangeDetectorRef, 
    private remoteService: RemoteService, 
    private brComService: BrComService,
    public alertCtrl: AlertController, 
    private pushService: PushService,
    public navCtrl: NavController, 
    private loadingCtrl: LoadingController, 
    public platform: Platform, 
    public network: Network, 
    public brComDao: BrComDao, 
    private contatoLocal: ContatoLocalProvider, 
    private areaLocalProvider: AreaLocalProvider,
    private empresaLocalProvider: EmpresaLocalProvider,
    private menuController: MenuController) {
    this.aba = "0";
    this.brComService.atualizaListaMensagensNaoLidas();
    this.brComService.notificaMensagemRecebidaPendente();
    this.empresa = empresaLocalProvider.getEmpresa();
    this.calcularVariaveis();
    this.subscriptions = new Subscription();
    this.definirVariaveisEmpresa();
    this.recarregarImagensQuandoConVoltar();
  }


  ngOnInit() {
    this.pushService.checkMsgServer(); // importante, serve para fazer a primeira busca de mensagens
    const subEmpresa = this.empresaLocalProvider.$empresa.subscribe(
      (empresa: any) => {
        this.empresa = empresa;
        this.atualizarEmpresa();
      }
    )
    this.subscriptions.add(subEmpresa);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private async definirVariaveisEmpresa() {
    this.appDomain = this.brComService.readAppDomain();
  }

  ionViewWillEnter() {
    let rec = this.getEmpresaAtual();
    this.content.resize();
    if (this.autenticado) {
      this.brComService.confirmaUsuarioLogado(rec.CodEmpresa, rec.CodUsuario);
    }
    this.definirLayoutPreferencial(rec);
  }

  calcularVariaveis() {
    let rec = this.getEmpresaAtual();
    this.autenticado = rec.Autenticado;
    this.MostrarMensagemTrocarSenhaPadrao = rec.MostrarMensagemTrocarSenhaPadrao;
    this.URLLogotipoEmpresa = this.obtemUrlImagemEmpresa();
    if (rec.Atalhos) {
      this.atalhos = rec.Atalhos;
    } else {
      this.atalhos = [];
    }
    this.nomeEmpresa = rec.NomeEmpresa;
    this.mostraFacebook = rec.Facebook != "";
    this.mostraTwitter = rec.Twitter != "";
    this.mostraWeb = rec.Site != "";
    this.definirLayoutPreferencial(rec);
    if (this.autenticado) {
      if (this.MostrarMensagemTrocarSenhaPadrao) {
        this.mensagemTrocarSenhaPadrao(rec.CodEmpresa, rec.CodUsuario, rec.URLTrocaSenhaEmpresa, rec.RecuperaSenha);
      }
    }
  }

  private definirLayoutPreferencial(rec: any): void {
    const layout = this.brComDao.recuperarLayoutPreferencial(rec.CodEmpresa);
    if (layout) {
      this.tipoLayout = layout;
    } else {
      this.brComDao.gravarLayoutPreferencial(rec.LayoutRotinas, rec.CodEmpresa);
      this.tipoLayout = rec.LayoutRotinas;
    }
  }

  mensagemTrocarSenhaPadrao(codEmpresa: number, codUsuario: number, url: string, idLogin: string){
    this.brComService.removerMensagemTrocarSenhaPadrao(codEmpresa, codUsuario);

    this.alertCtrl.create({
      title: this.getEmpresaAtual().NomeEmpresa, 
      message: "Informar sua senha agora?", 
      buttons: [{
          text: "Sim", handler: () => {
            this.brComService.iniciaPaginaNavegador(url + idLogin);
          }
        }, {
          text: "Não",
          role: "cancel"
        }]
    }).present();
  }

  public async facebook(): Promise<void> {
    const load = this.loadingCtrl.create({content: "Aguarde ..."});
    await load.present();
    const rec = this.getEmpresaAtual();
    await this.brComService.facebook(rec.Facebook);
    load.dismiss();
  }

  public facebookUrl(){
    let rec = this.getEmpresaAtual();
   // this.browserTab.openUrl(rec.Facebook);
  }

  public hasSite(): boolean {
    const site = this.getUrlSite();
    return site && site.length > 0;
  }

  private getUrlSite(): string {
    let rec = this.getEmpresaAtual();
    return rec.Site;
  }

  public site() {
    this.mostraLoading();
   // this.browserTab.openUrl(this.getUrlSite());
  }

  public entrar() {
    let idDevice = readValueFromConfig(this.pushService.localStorageKeyName(), 'idDevice');
    if (!idDevice) {
      this.pushService.init();
      this.alertCtrl.create({ title: this.getEmpresaAtual().NomeEmpresa, message: "Servidor indisponível. Tente mais tarde.", buttons: ["OK"] }).present();      
      return;
    }
    this.alertCtrl.create({
      title: this.getEmpresaAtual().NomeEmpresa, message: "Informe sua senha", inputs: [{ name: "password", type: "text" }], buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Entrar',
          handler: fields => {
            this.logar(this, fields.password, this.getEmpresaAtual().NomeEmpresa);
          }
        }]
    }).present();
  }
  
  public abrirAtalho(atalho: Atalho) {

    let rec = this.getEmpresaAtual();
    let url = atalho.url;
    let urlSerach = String(url).toLowerCase();

    if (urlSerach.includes("facebook")){
      this.facebook();
    } else {
      let load = this.brComService.criaMensagemLoading();
      load.present().then(
        () => {
          if (urlSerach.includes(":id_login")) {
            url = url.replace(":id_login", rec.RecuperaSenha);
            this.brComService.iniciaPaginaNavegador(url)
          } else {
            this.brComService.abrePaginaComTipoURL(url);
          }
          load.dismiss();
        });
    }
  }

  public denuncia() {
    let rec = this.getEmpresaAtual();
    this.brComService.iniciaPaginaDenunciaLista(rec.CodEmpresa);
  }

  public abrirConversaWatson(): void {
    let rec = this.getEmpresaAtual();
    this.brComService.iniciaPaginaConversaWatson(rec.CodEmpresa);
  }

  public sair() {
    let rec = this.getEmpresaAtual();
    this.autenticado = false;
    this.brComService.removeAutenticacao(rec.CodEmpresa, rec.CodUsuario);
    this.reloadInfo();
  }

  public logar(th: any, password: string, nomeEmpresa: string) {
      let rec = this.getEmpresaAtual();
      this.remoteService.remoteCallComLoading('ligaAparelhoUsuario', {
        "senha": password,
        "imei": readValueFromConfig(this.pushService.localStorageKeyName(), 'deviceCode'),
        "cod_empresa": rec.CodEmpresa,
        "cod_usuario": rec.CodUsuario
      },
        function (result: any) {  
          if (result.executado) {
            th.brComService.empresaAutenticadaComSenhaPersonalizada(rec.CodEmpresa, rec.CodUsuario);
            th.brComService.confirmaUsuarioLogado(rec.CodEmpresa, rec.CodUsuario);
            th.reloadInfo();
          } else {
            th.alertCtrl.create({ title: nomeEmpresa, message: result.msg, buttons: ["OK"] }).present();
          }
      }
    )
  }

  public reloadInfo() {
    this.empresa = this.getEmpresaAtual();
    this.calcularVariaveis();
    this.content.resize();
  }

  obtemUrlImagemEmpresa():string {
    const hashLogotipoEmpresa = this.obtemImagemEmpresa();
    return this.brComService.obtemUrlLogotipoEmpresa(hashLogotipoEmpresa);
  }

  obtemImagemEmpresa():string {
    let rec = this.getEmpresaAtual();
    if (rec && rec.HashLogotipoEmpresa)
      return rec.HashLogotipoEmpresa;
    else
      return "8db4380e774ad6f7e8c1aadb486b4290039cf0b7"; // logotipo InfoBr
  }

  mostraLoading() {
    this.loadingCtrl.create({
      content: 'Aguarde ...',
      duration: 1000
    }).present();
  }

  private atualizarEmpresa(): void {
    if (this.autenticado){
      this.reloadInfo();
      try {
        this.lc.detectChanges();
      } catch (err) {
        console.log("desprezado erro em detectChanges InicialPage");
      }
    }
  }

  public isLayoutDefault(): boolean {
    return this.tipoLayout === TipoLayout.LISTA || this.tipoLayout === undefined;
  }

  public isLayoutAlternativo(): boolean {
    return this.tipoLayout === TipoLayout.GRADE;
  }

  public isBlocoBotoesRedeSocialDisponivel():boolean {
    return this.mostraFacebook || this.mostraTwitter;
  }

  public isAprasc():boolean {
    return this.appDomain == "aprasc";
  }

  public isLideranca():boolean {
    return this.appDomain == "lideranca";
  }

  public getEmpresaAtual(): any {
    return this.empresaLocalProvider.getEmpresa();
  }

  public getLinkFacebook():string {
    const empresaAtual = this.getEmpresaAtual();
    return empresaAtual.Facebook;
  }

  public getLinkTwitter():string {
    const empresaAtual = this.getEmpresaAtual();
    return empresaAtual.Twitter;
  }

  public getAtalhoGed(): Atalho {
    const atalho: Atalho = {
      texto: "Enviar documentos",
      descricao: "",
      url: "",
      hashImagem: "",
      ordem: 1,
      imagemLocal: 'assets/img/contracheque.png',
    }
    return atalho;
  }

  public alterarAutenticacao(autenticacao: boolean) {
    this.autenticado = autenticacao;
  }

  public recarregarImagensQuandoConVoltar(): void {
    const subConexao = this.network.onConnect().subscribe(
      () => {
        const timestamp = new Date().getTime();
        this.URLLogotipoEmpresa = `${this.URLLogotipoEmpresa}?${timestamp}`
        for(const atalho of this.atalhos) {
          atalho.imagem = `${atalho.imagem}?${timestamp}`
        }
      }
    );
    this.subscriptions.add(subConexao);
  }

  public alterarLayout(layout: string): void {
    let valorLayout = TipoLayout[layout.toUpperCase()];
    if (valorLayout) {
      this.tipoLayout = valorLayout;
    } else {
      this.tipoLayout = TipoLayout.LISTA;
    }
  }

  public enviarEmailGED(): void {
    let rec = this.getEmpresaAtual();
    this.brComService.iniciarPaginaImagemGED(rec.Email);
  }

  public trocarAbaSegment(aba: string): void {
    this.slides.slideTo(+aba);
  }

  public trocarAbaSwipe(): void {
    const activatedIndex = this.slides.getActiveIndex();
    if (!(activatedIndex > 1 || activatedIndex < 0)) {
      this.aba = this.slides.getActiveIndex() + '';
    };
  }

  public adicionarConversa(): void {
    const empresaAtual = this.getEmpresaAtual();
    this.navCtrl.push(AdicionarContatoPage, {
      idUsuario: empresaAtual.IdUsuario,
      idEmpresa: empresaAtual.IdEmpresa
    });
  }

  public toggleMenu() {
    const menu = this.menuController.get();
    if (!menu.enabled) {
      menu.enable(true);
    }
    this.menuController.toggle();
  }

  public selecionarArea(area: Area) {
    this.contatoSelecionado = undefined;
    this.areaSelecionada = area;
  }

  public selecionarContato(contato: Contato) {
    if (this.contatoSelecionado && this.contatoSelecionado.idContato === contato.idContato) {
      //já está selecionado
      return
    }
    this.areaSelecionada = undefined;
    this.contatoSelecionado = contato;
  }
}


// WEBPACK FOOTER //
// ./src/pages/inicial/inicial.ts